/**
 * Hình thức thanh toán giấy đề nghị chi FPT
 */
export default {
  Cash: 1, // Tiền mặt
  Transfer: 2, // Chuyển khoản
};
